import React, { useState } from "react";
import { css } from "@emotion/react";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ConfirmModal, PageTable, Title } from "@src/components";
import { getColumns } from "./CommunityListColumns";
import { initCommunityListFilters, useCommunityList, useDeleteCommunityPost } from "./service";
import { CommunityListFilterType, CommunityPostListItemDto } from "./service/types";

const CommunityList = () => {
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const [params, setParams] = useState<CommunityListFilterType>(initCommunityListFilters);
    const [deleteTarget, setDeleteTarget] = useState<CommunityPostListItemDto | null>(null);

    const { data } = useCommunityList(params);
    const deletePost = useDeleteCommunityPost();

    const handleViewDetail = (post: CommunityPostListItemDto) => {
        // 상세 데이터가 즉시 반영되도록 캐시를 비우고 이동
        queryClient.removeQueries(["communityDetail", post.postNo]);
        navigate(`/community/detail/${post.postNo}`);
    };

    const columns = getColumns(handleViewDetail, (post) => setDeleteTarget(post));

    const handleDelete = () => {
        if (!deleteTarget) {
            return;
        }
        deletePost.mutate(deleteTarget.postNo, {
            onSuccess: () => {
                setDeleteTarget(null);
            },
            onError: () => {
                alert("글 삭제에 실패했습니다.");
                setDeleteTarget(null);
            },
        });
    };

    return (
        <div css={listStyle}>
            <Title title="커뮤니티 글 관리" />
            <div css={tableDivStyle}>
                <PageTable
                    columns={columns}
                    data={data?.list ?? []}
                    initialState={{
                        pageIndex: 0,
                        pageSize: params.limit,
                    }}
                    FixedHeight={500}
                    showTotalCount={true}
                    totalCount={data?.totalCount ?? 0}
                    handlePageChange={(index: number) => {
                        const page = index + 1;
                        setParams({ ...params, page });
                    }}
                    forcePageNumber={params.page}
                ></PageTable>
            </div>
            <ConfirmModal
                isModalShow={Boolean(deleteTarget)}
                buttonText="삭제"
                handleCancel={() => setDeleteTarget(null)}
                handleOk={handleDelete}
            >
                정말 삭제하시겠습니까?
            </ConfirmModal>
        </div>
    );
};

export default CommunityList;

const listStyle = css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 40px;
`;

const tableDivStyle = css`
    margin-top: 43px;
    width: 100%;
    height: 80vh;
`;
